module.exports = require("core-js/library/fn/map");


//////////////////
// WEBPACK FOOTER
// ../node_modules/@babel/runtime/core-js/map.js
// module id = 147
// module chunks = 0 1